import { stubFalse } from 'lodash';
import { MODULE_NAME as CAMPAIGNS_MODULE } from 'modules/campaigns/config/routes/module';
import { FEATURE_FLAGS } from 'modules/taboola-common-frontend-modules/account-configurations';
import { isProgrammaticAccount } from '../../../../../../account-management/accountType';
import { realtimeReportVisibilityCondition } from '../../../../../config/report-predicates/realtimeReportVisibilityCondition';
import { TITLE, ID, CVR, AVERAGE_CPC, CONVERSIONS } from '../../fields';
import { FILTER_TYPE } from '../../filters';
import { REPORT_PRESET } from '../../pickers';
import columnDefinitions from './columnDefinitions';
import { CREATIVE_REALTIME_REPORT_ID } from './creativeRealtimeReportId';
import footerColumnDefinitions from './footerColumnDefinitions';
import { graphConfigs } from './graph';
import { performanceColumns, customColumns, defaultColumns, setupColumns } from './reportPresets';

export const creativeRealtimeReportConfig = {
    id: CREATIVE_REALTIME_REPORT_ID,
    label: 'Ads',
    permissions: ['TA_REALTIME_CREATIVE_REPORT'],
    accountConfigurations: {
        [FEATURE_FLAGS.ONLY_PERFORMANCE_REPORTS]: 'false',
        [FEATURE_FLAGS.HIDE_HEAVY_ACCOUNT_CREATIVES_REPORT]: 'false',
        [FEATURE_FLAGS.IS_DCO_ACCOUNT]: 'false',
    },
    visibilityCondition: ({ isRealtime, selectedAccount, ...rest }) =>
        realtimeReportVisibilityCondition({ isRealtime, selectedAccount, ...rest }) &&
        !isProgrammaticAccount(selectedAccount),
    module: CAMPAIGNS_MODULE,
    endpoint: 'top-campaign-realtime-report-by-creative',
    graph: graphConfigs,
    columnsDef: columnDefinitions,
    rowIdField: ID.field,
    presets: {
        [REPORT_PRESET.DEFAULT]: { columns: defaultColumns },
        [REPORT_PRESET.PERFORMANCE]: { columns: performanceColumns },
        [REPORT_PRESET.SETUP]: { columns: setupColumns },
    },
    customPreset: { columns: customColumns, initialState: defaultColumns },
    footerColumnDef: footerColumnDefinitions,
    rowHeight: 62,
    comfortableRowHeight: 112,
    searchPlaceholderMsgId: 'app.reports.byCreative.search.placeholder',
    searchField: TITLE.field,
    inlineEditPermissions: ['CAMPAIGN_EDIT'],
    sortMap: {
        [CVR.field]: 'cpaConversionRate',
        [AVERAGE_CPC.field]: 'cpc',
        [CONVERSIONS.field]: 'cpaActionsNum',
        [ID.field]: 'item_id',
    },
    customRestrictedFilters: {},
    filters: [
        {
            id: FILTER_TYPE.PLATFORM,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
        {
            id: FILTER_TYPE.COUNTRY,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
        {
            id: FILTER_TYPE.SITE,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
        },
        {
            id: FILTER_TYPE.ITEMS,
            multiSelect: true,
            minVisibleCount: 4,
            permissions: ['TA_REAL_TIME_REPORT_FILTERS'],
            // This is made to hide temporary this filter
            visibilityCondition: stubFalse,
        },
    ],
};

export default creativeRealtimeReportConfig;
